import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { accessSessionData } from "../../utils/helper/authHelper";
import { _sessionKeys, _sessionType } from "../../utils/Constant";
import { _vendorAdminRoutes } from "../../utils/appRouter";
import { fetchNotification, markAllNotificationsRead, markNotificationRead } from "../../action/notificationAction";
import {formatFileURL } from "../../utils/helper/appHelpers";
import logo from "../../assets/profile.png";

const Header = () => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // const user = accessSessionData(_sessionType.getdata, _sessionKeys.loggedInUser);

  const loggedInUser = accessSessionData(
  _sessionType.getdata,
  _sessionKeys.loggedInUser
);


  const handleLogout = () => {
    accessSessionData(_sessionType.removeData, _sessionKeys.loggedInUser);
    accessSessionData(_sessionType.removeData, _sessionKeys.access_token);
    navigate('/')
  };

  const formatNotificationTime = (createdAt) => {
    const now = new Date();
    const created = new Date(createdAt);
    const diffMs = now - created;
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays === 0) {
      if (diffHours > 0) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
      if (diffMinutes > 0) return `${diffMinutes} min ago`;
      return "Just now";
    }

    return `${created.getDate().toString().padStart(2, "0")}-${(created.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${created.getFullYear()} | ${created.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  };

  const getNotification = async () => {
    try {
      const resp = await fetchNotification();
      if (resp && resp.data && resp.data.rows) {
        setNotifications(resp.data.rows);
      } else {
        setNotifications([]);
      }
    } catch (error) {
    }
  };

  const handleMarkRead = async (id) => {
    try {
      const resp = await markNotificationRead(id);
      if (resp.success) {
        setNotifications((prev) =>
          prev.map((n) => (n._id === id ? { ...n, isRead: true } : n))
        );
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!loggedInUser) navigate(_vendorAdminRoutes.login);
    getNotification();
  }, []);

  const toggleDropdown = () => setShowDropdown((prev) => !prev);

  const markAllAsRead = async () => {
    
    const res = await markAllNotificationsRead();

    if (res.success) {
      setNotifications((prev) =>
        prev.map((n) => ({
          ...n,
          isRead: true,
        }))
      );
    }
  };

  return (
    <div className="content-header pb-0">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-md-4 col-1">
            <Link className="d-block d-md-none" data-widget="pushmenu" href="#" role="button">
              <img src="/img/menu-left-alt.svg" alt="/" />
            </Link>
            <Link className="d-none d-sm-block" href="#" role="button">
              <img src="/images/logo.svg" height="70px" alt="Logo" />
            </Link>
          </div>

          <div className="col-md-7 col-11 user-profile offset-md-1">
            <div className="float-right notificationbar  mt-sm-3" ref={dropdownRef}>
              <div
                className="d-inline-block cursor-pointer position-relative"
                onClick={toggleDropdown}
              >
                <img src="/img/notification.svg" className="float-none" alt="/" />
                <span className="top-notification">
                {notifications.filter((n) => !n.isRead).length > 0 
                  ? notifications.filter((n) => !n.isRead).length 
                  : ""}
              </span>
              </div>

              {showDropdown && (
                <div
                  className="dropdown-menu dropdown-menu-md tableaction notificationtab useraction-dropdown dropdown-menu-right show"
                  style={{ display: "block", position: "absolute", right: 0, zIndex: 1000 }}
                >
                  <div className="px-3 py-2 border-bottom">
                    <div className="d-flex align-items-center justify-content-between">

                      <h5 className="mb-0 font-weight-bold">Notifications</h5>

                    
                      <div className="d-flex align-items-center">

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            markAllAsRead();
                          }}
                          className="btn btn-link p-0 f-12 text-theme"
                          style={{ textDecoration: "none" }}
                        >
                          Mark all as read
                        </button>

             
                        <span
                          style={{
                            width: "1px",
                            height: "16px",
                            background: "#ddd",
                            margin: "0 10px",
                          }}
                        />

                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowDropdown(false);
                          }}
                          className="bg-transparent border-0 p-0"
                          aria-label="Close"
                        >
                          <i className="fa fa-times text-muted" style={{ fontSize: "18px" }} />
                        </button>

                      </div>
                    </div>
                  </div>
                  <div className="notify-detil" style={{ maxHeight: "300px", overflowY: "auto" }}>
                    {notifications.length > 0 ? (
                      notifications.map((item) => (
                        <button
                          key={item._id}
                          type="button"
                          className="d-block text-left bg-transparent border-0 w-100 p-0"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMarkRead(item._id);
                          }}
                        >
                          <div className={`notifylist ${!item.isRead ? "bg-light" : ""} p-2`}>
                            <strong>{item.title}</strong>
                            <br />
                            {item.description}
                            <br />
                            <span className="mt-1 d-block f-12 font-weight-normal">
                              <i className="fa fa-calendar"></i>{" "}
                              {formatNotificationTime(item.createdAt)}
                            </span>
                          </div>
                        </button>
                      ))
                    ) : (
                      <div className="text-center py-3 text-muted">
                        No notifications found
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* User Profile Dropdown */}
            <div className="float-right dropdown userData">
              <Link data-toggle="dropdown" href="#" aria-expanded="true">
                <p>
                  {/* {loggedInUser?.userName}{" "} */}
                  <span>{loggedInUser?.businessInfo?.name}</span>
                </p>
                <img
                  src={loggedInUser?.profilePic ? formatFileURL(loggedInUser?.profilePic) : logo}
                  className="img-circle mr-1"
                  width="36"
                  alt="/"
                />{" "}
                <img src="/img/dot.svg" className="float-none" alt="/" />
              </Link>
              <div
                className="dropdown-menu dropdown-menu-md tableaction useraction-dropdown dropdown-menu-right"
                style={{ left: "inherit", right: "0px" }}
              >
                <ul>
                  <li>
                    <Link to="/vendor-admin/company-profile">
                      <i className="fa fa-building-o"></i> Company Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/vendor-admin/change-password" data-toggle="modal">
                      <i className="fa fa-lock"></i> Change Password
                    </Link>
                  </li>
                  <li style={{cursor : "pointer"}}>
                    <button onClick={handleLogout} style={{background : "white", border: "none" }}>
                      <i className="fa fa-sign-out"></i> Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
